import React, { useState } from "react";
import { geoPath } from "d3-geo";
import { feature } from "topojson-client";
import us from "us-atlas/states-albers-10m.json";
import { US_STATES } from "@/pages/landing/QuizForm";

const NAME_TO_CODE = Object.fromEntries(US_STATES.map(([c, n]) => [n, c]));
const path = geoPath();
const SHAPES = feature(us, us.objects.states).features
  .map((f) => ({ code: NAME_TO_CODE[f.properties.name], name: f.properties.name, d: path(f), c: path.centroid(f) }))
  .filter((s) => s.code);

export const HEAT = ["#F4F4F5", "#FECACA", "#F87171", "#DC2626", "#991B1B", "#450A0A"];

export function heatColor(n, max) {
  if (!n) return HEAT[0];
  return HEAT[Math.min(5, 1 + Math.floor((n / Math.max(1, max)) * 4.999))];
}

function Legend({ max }) {
  return (
    <div className="flex items-center gap-1 text-[10px] font-mono" data-testid="demand-map-legend">
      <span>0</span>
      {HEAT.map((c) => <span key={c} className="w-5 h-2.5 border border-black/20" style={{ background: c }} />)}
      <span>{max}</span>
      <span className="ml-1 text-zinc-500 uppercase tracking-widest">unmatched leads</span>
    </div>
  );
}

export const UsStateMap = ({ counts, selected, onSelect }) => {
  const [hover, setHover] = useState(null);
  const max = Math.max(0, ...Object.values(counts));
  return (
    <div className="relative" data-testid="demand-map">
      <svg viewBox="0 0 975 610" className="w-full h-auto" role="img" aria-label="US map of unmatched leads">
        {SHAPES.map((s) => (
          <path key={s.code} d={s.d} fill={heatColor(counts[s.code], max)}
                stroke={selected === s.code ? "#000" : "#fff"} strokeWidth={selected === s.code ? 3 : 0.8}
                className="cursor-pointer transition-opacity duration-150 hover:opacity-75"
                onClick={() => onSelect(selected === s.code ? null : s.code)}
                onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(null)}
                data-testid={`demand-map-state-${s.code}`} />
        ))}
        {SHAPES.filter((s) => counts[s.code]).map((s) => (
          <text key={`t-${s.code}`} x={s.c[0]} y={s.c[1]} textAnchor="middle" dominantBaseline="central"
                fontSize="12" fontWeight="700" className="pointer-events-none font-mono"
                fill={counts[s.code] / Math.max(1, max) > 0.4 ? "#fff" : "#000"}>
            {counts[s.code]}
          </text>
        ))}
      </svg>
      {hover && (
        <div className="absolute top-2 left-2 bg-black text-white px-2 py-1 text-[11px] font-mono pointer-events-none" data-testid="demand-map-tooltip">
          {hover.name} · {counts[hover.code] || 0} unmatched
        </div>
      )}
      <Legend max={max} />
    </div>
  );
};
